import { Flex, Text } from "@scaleaq/sui-react";
import styling from "./Loading.module.scss";
import clsx from "clsx";

export namespace Loading {
	export type Props = Flex.Column.Props & {
		title?: string;
		text?: string;
		size?: "small" | "medium" | "large";
	};
}

export const Loading = (props: Loading.Props) => {
	const { className, text, alignment="center", gap="medium", size = "medium", title, ...restProps } = props;

	return (
		<Flex.Column
			className={clsx(styling.wrapper, {
				[`${className}`]: className,
			})}
			alignment={alignment}
			gap={gap}
			{...restProps}
		>
			<div
				className={clsx(styling.spinner, {
					[styling[`spinner--${size}`]]: size,
				})}
			>
				<div className={styling["bounce1"]} />
				<div className={styling["bounce2"]} />
				<div className={styling["bounce3"]} />
			</div>

			{title && <Text.Heading.Large>{title}</Text.Heading.Large>}
			{text && (
				<Text.Heading.Medium className={styling.text}>
					{text}
				</Text.Heading.Medium>
			)}
		</Flex.Column>
	);
};
